import type { Sponsors as SponsorsData } from '@/types/api'
import { motion } from 'framer-motion'
import { ExternalLink } from 'lucide-react'

export function SponsorsStrip({ sponsors }: { sponsors: SponsorsData['sponsors'] }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 items-stretch">
      {sponsors.map((s, i) => (
        <motion.a
          key={s.name}
          href={s.url}
          target={s.url === '#' ? undefined : '_blank'}
          rel="noreferrer"
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-10% 0px' }}
          transition={{ delay: i * 0.06, duration: 0.4 }}
          whileHover={{ y: -3 }}
          className="group relative flex flex-col items-center justify-center rounded-xl border border-border bg-card p-4 min-h-[110px] hover:border-cosmos-green/60 hover:shadow-md transition-all"
        >
          {s.logo ? (
            <img
              src={s.logo}
              alt={s.name}
              className="max-h-11 max-w-[80%] object-contain opacity-90 group-hover:opacity-100 transition-opacity"
              loading="lazy"
            />
          ) : (
            <span className="font-display uppercase text-sm tracking-wider text-cosmos-green text-center leading-tight">
              {s.name}
            </span>
          )}
          <div className="mt-3 text-[10px] uppercase tracking-widest text-muted-foreground text-center leading-tight">
            {s.note ?? s.name}
          </div>
          {s.url !== '#' && (
            <ExternalLink className="h-3 w-3 absolute top-2 right-2 text-muted-foreground/60 opacity-0 group-hover:opacity-100 transition-opacity" />
          )}
        </motion.a>
      ))}
    </div>
  )
}
